const DEBOUNCE_DELAY = 300;

const handleCountrySelection = (e) => {
  e.preventDefault();
  const countryCode = e.currentTarget.dataset.value;
  
  // Set cookie with 30 days expiration
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  document.cookie = `localization=${countryCode}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
  
  // Update hidden input
  document.querySelector('input[name="country_code"]').value = countryCode;
  
  // Refresh page to apply changes
  window.location.reload();
};

const handleNoResults = (searchInput, hasVisibleItems) => {
  // Remove existing no-results message if it exists
  const existingMessage = document.querySelector(".no-results-message");
  if (existingMessage) {
    existingMessage.remove();
  }

  // Show no results message if needed
  if (!hasVisibleItems) {
    const message = document.createElement("div");
    message.className = "no-results-message dropdown-item";
    message.textContent = "No countries found";

    // Insert after the search input
    searchInput.closest(".dropdown-header").after(message);
  }
};

const filterCountries = (searchTerm, dropdownItems, searchInput) => {
  let hasVisibleItems = false;

  dropdownItems.forEach((item) => {
    const countryName = item
      .querySelector(".dropdown-language-item")
      .textContent.toLowerCase();
    const isMatch = countryName.includes(searchTerm);

    // Use classList instead of style manipulation
    item.classList.toggle("hidden", !isMatch);

    if (isMatch) {
      hasVisibleItems = true;
    }
  });

  // Handle no results state
  handleNoResults(searchInput, hasVisibleItems);
};

const initCountryLocalization = () => {
  const searchInput = document.getElementById("country-filter-input");
  const dropdownItems = document.querySelectorAll(".js-dropdown-item");
  let debounceTimeout = null;

  // Initialize country selection
  dropdownItems.forEach(item => {
    item.addEventListener('click', handleCountrySelection);
  });

  // Initialize search if input exists
  if (searchInput) {
    const handleSearch = (e) => {
      // Clear the previous timeout
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      // Debounce the search to improve performance
      debounceTimeout = setTimeout(() => {
        const searchTerm = e.target.value.toLowerCase().trim();
        filterCountries(searchTerm, dropdownItems, searchInput);
      }, DEBOUNCE_DELAY);
    };

    const handleKeyDown = (e) => {
      // Prevent form submission on enter
      if (e.key === "Enter") {
        e.preventDefault();
        searchInput.blur();
      }
    };

    searchInput.addEventListener("input", handleSearch);
    searchInput.addEventListener("keydown", handleKeyDown);
  }
};

// Initialize on load
initCountryLocalization();